import GamePiece from "./game-piece.js";

export default class GamePieceUnturned extends GamePiece {

    constructor(piece, gameBoard) {
        super(piece, gameBoard);
        this.isUnturned = true;
        this.canFlip = true;
    }

    get isActive() { return false; }

    canMoveByDirection = () => false;
    canAttackByDirection = () => false;

    get allAvailablePiecesForAction() { return [this]; }

}